module.exports = __webpack_public_path__ + "static/media/nz.83b9dd22.svg";